import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import Keycloak from 'keycloak-js';

/**
 * Route guard -- requires an authenticated Keycloak session. If none exists,
 * redirects through keycloak.login() back to /dashboard.
 *
 * keycloak-angular v21 -- inject(Keycloak) returns the underlying Keycloak
 * instance from keycloak-js (no more KeycloakService wrapper). State is read
 * via the boolean `keycloak.authenticated` property; navigation uses
 * keycloak.login({ redirectUri }).
 */
export const authGuard: CanActivateFn = async () => {
  const keycloak = inject(Keycloak);
  if (keycloak.authenticated) return true;
  await keycloak.login({ redirectUri: window.location.origin + '/dashboard' });
  return false;
};
